import React from 'react';
import { Table, Button, DropdownButton, MenuItem } from 'react-bootstrap';
import { getUser } from '../../utils/Common';
import { getReadableAccessLevel, getAccessLevelClass } from '../access-control/utils';

export default function SharedCamerasTable({
  otherCaps,
  user,
  handleAccessChange,
  renderLastAccess,
  isMobile,
  history
}) {
  return (
    <Table bordered condensed hover className="cap-access-table user-camera-access-table">
      <thead>
        <tr>
          <th>Camera</th>
          <th>Access Level</th>
          <th>Last Access</th>
          <th>Builder</th>
        </tr>
      </thead>
      <tbody>
        {otherCaps.map(cap => {
          const tierClass = getAccessLevelClass(cap.accessType, user);

          return (
            <tr key={cap.userCapId}>
              <td className="cap-name-cell">
                <Button
                  bsStyle="default"
                  onClick={() => history.push(`/caps/${cap.capId}`)}
                  className="cap-name-button access-control-cap-link"
                  bsSize={isMobile ? 'xs' : 'small'}
                >
                  {cap.name}
                </Button>
              </td>
              <td className={`cap-access-cell ${tierClass}`}>
                <DropdownButton
                  title={getReadableAccessLevel(cap.accessType, user, isMobile)}
                  id={`dropdown-shared-${cap.userCapId}`}
                  className={`access-tier-dropdown ${tierClass}`}
                  onSelect={(newType) => handleAccessChange(user.userId, cap.capId, newType)}
                  bsSize={isMobile ? 'xs' : 'small'}
                >
                  <MenuItem eventKey="No Access" className="access-tier--none">
                    {getReadableAccessLevel('No Access', user, isMobile)}
                  </MenuItem>
                  <MenuItem eventKey="DEMO" className="access-tier--demo">
                    {getReadableAccessLevel('DEMO', user, isMobile)}
                  </MenuItem>
                  <MenuItem eventKey="VIEWER" className="access-tier--viewer">
                    {getReadableAccessLevel('VIEWER', user, isMobile)}
                  </MenuItem>
                  <MenuItem eventKey="OWNER" className="access-tier--owner">
                    {getReadableAccessLevel('OWNER', user, isMobile)}
                  </MenuItem>
                  {getUser().role === 'ADMIN' && (
                    <MenuItem eventKey="SALES_DEMO" className="access-tier--sales-demo">
                      {getReadableAccessLevel('SALES_DEMO', user, isMobile)}
                    </MenuItem>
                  )}
                </DropdownButton>
              </td>
              <td className="user-camera-access-time">{renderLastAccess(cap.capId)}</td>
              <td className="cap-name-cell">
                <Button
                  bsStyle="default"
                  onClick={() => history.push(`/accesscontrol/${cap.builderId}`)}
                  className="cap-name-button access-control-cap-link"
                  bsSize={isMobile ? 'xs' : 'small'}
                >
                  {cap.builder.name}
                </Button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}
